@use '@/scss/underscore' as _;

.notification {
  padding: _.unit(6);
}
